import {
  MODULE_TYPE_GARDEROB_U
} from '../../resource/ModuleTypes'

export const state = {}

export const getters = {
  showDepthTips: (state, getters, rootState) => {
    let side = 0

    if (rootState.questions.sizeModuleCorrect.left && rootState.questions.sizeModuleCorrect.right) {
      side = rootState.questions.sizeModuleCorrect.left > rootState.questions.sizeModuleCorrect.right
        ? rootState.questions.sizeModuleCorrect.left
        : rootState.questions.sizeModuleCorrect.right
    } else if (rootState.questions.sizeModuleCorrect.right) {
      side = rootState.questions.sizeModuleCorrect.right
    } else if (rootState.questions.sizeModuleCorrect.left) {
      side = rootState.questions.sizeModuleCorrect.left
    }

    let middleL = 0

    if (rootState.questions.sizeModuleCorrect.middle) {
      middleL = (rootState.questions.sizeModuleCorrect.middle - 85) - (Math.floor((rootState.questions.sizeModuleCorrect.middle - 85) / 50) * 50)
    }

    return (MODULE_TYPE_GARDEROB_U !== rootState.moduleCurrent.moduleType && middleL >= 20) ||
      ((side - (Math.floor(side / 50) * 50)) >= 20)
  },

  showTopTips: (state, getters, rootState) => {
    return rootState.questions.sizeTop >= 250
  },

  showWidthTips: (state, getters, rootState) => {
    return MODULE_TYPE_GARDEROB_U === rootState.moduleCurrent.moduleType && rootState.questions.sizeModuleCorrect.middle - 320 >= 20
  }
}

export const muttations = {}

export const actions = {}



// WEBPACK FOOTER //
// ./resources/js/store/modules/tips.js